import { render, staticRenderFns } from "./SandHollow.vue?vue&type=template&id=015608a4&scoped=true&"
import script from "./SandHollow.vue?vue&type=script&lang=js&"
export * from "./SandHollow.vue?vue&type=script&lang=js&"
import style0 from "./SandHollow.vue?vue&type=style&index=0&id=015608a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015608a4",
  null
  
)

export default component.exports